import { db } from '../services/firebase';
import { collection, addDoc } from 'firebase/firestore';

export const sendEmail = async (data) => {
    try {
        const collectionRef = collection(db, "leads");

        const emailData = {
            fullName: data.fullName,
            email: data.email,
            phone: data.phone,
            message: data.message,
            purposeOfContact: data.purposeOfContact,
            hasBeenReviewed: false
        }

        const docRef = await addDoc(collectionRef, emailData);

        if (docRef.id) {
            return { success: true };// open dialog with success message
        }
        console.log('Document written with ID: ', docRef);
    } catch (e) {
        console.error("Error adding document: ", e);
    }
}
